import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  size?: number | string;
  width?: number | string;
  height?: number | string;
}

export function HomeIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5636_5796)">
        <path
          d="M6.1973 2.35064C6.16656 2.31935 6.12568 2.30188 6.08315 2.30188C6.04062 2.30188 5.99973 2.31935 5.969 2.35064L2.16879 6.21497C2.15265 6.2314 2.13981 6.25115 2.13105 6.27302C2.12229 6.29488 2.11778 6.31842 2.11781 6.34219L2.11719 9.969C2.11719 10.1555 2.18678 10.3343 2.31066 10.4662C2.43453 10.598 2.60255 10.6721 2.77773 10.6721H4.76144C4.84903 10.6721 4.93303 10.6351 4.99497 10.5691C5.05691 10.5032 5.09171 10.4138 5.09171 10.3206V7.33228C5.09171 7.28566 5.10911 7.24095 5.14008 7.20798C5.17104 7.17502 5.21305 7.1565 5.25684 7.1565H6.90821C6.95201 7.1565 6.99401 7.17502 7.02498 7.20798C7.05595 7.24095 7.07335 7.28566 7.07335 7.33228V10.3206C7.07335 10.4138 7.10814 10.5032 7.17008 10.5691C7.23202 10.6351 7.31602 10.6721 7.40362 10.6721H9.38649C9.56168 10.6721 9.72969 10.598 9.85357 10.4662C9.97745 10.3343 10.047 10.1555 10.047 9.969V6.34219C10.0471 6.31842 10.0426 6.29488 10.0338 6.27302C10.025 6.25115 10.0122 6.2314 9.99605 6.21497L6.1973 2.35064Z"
          fill={fill}
        />
        <path
          d="M10.932 5.49023L9.38801 3.91787V1.53186C9.38801 1.43862 9.35321 1.3492 9.29127 1.28327C9.22933 1.21734 9.14533 1.1803 9.05773 1.1803H8.06692C7.97932 1.1803 7.89532 1.21734 7.83338 1.28327C7.77144 1.3492 7.73664 1.43862 7.73664 1.53186V2.23499L6.54105 1.01814C6.42917 0.897729 6.2628 0.828735 6.08301 0.828735C5.90383 0.828735 5.73787 0.89773 5.62599 1.01836L1.23543 5.48979C1.10703 5.62163 1.09093 5.8385 1.20777 5.98132C1.23711 6.01737 1.27303 6.04669 1.31335 6.06749C1.35367 6.0883 1.39755 6.10015 1.44231 6.10233C1.48707 6.10451 1.53178 6.09697 1.57372 6.08017C1.61566 6.06337 1.65394 6.03766 1.68625 6.00461L5.96948 1.64788C6.00021 1.61658 6.0411 1.59912 6.08363 1.59912C6.12616 1.59912 6.16705 1.61658 6.19778 1.64788L10.4814 6.00461C10.5445 6.06903 10.629 6.10418 10.7164 6.10237C10.8039 6.10055 10.887 6.06192 10.9477 5.99495C11.0745 5.8552 11.0639 5.62449 10.932 5.49023Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5636_5796">
          <rect width="10.5687" height="11.25" fill="white" transform="translate(0.798828 0.125)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CardIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.45898 9.13635C1.45898 9.46269 1.58077 9.77567 1.79756 10.0064C2.01434 10.2372 2.30836 10.3668 2.61494 10.3668H9.55067C9.85725 10.3668 10.1513 10.2372 10.3681 10.0064C10.5848 9.77567 10.7066 9.46269 10.7066 9.13635V5.75256H1.45898V9.13635ZM2.82136 7.46643C2.82136 7.29161 2.8866 7.12394 3.00274 7.00032C3.11887 6.8767 3.27638 6.80725 3.44062 6.80725H4.43144C4.59568 6.80725 4.75319 6.8767 4.86932 7.00032C4.98546 7.12394 5.0507 7.29161 5.0507 7.46643V7.90588C5.0507 8.08071 4.98546 8.24837 4.86932 8.37199C4.75319 8.49561 4.59568 8.56506 4.43144 8.56506H3.44062C3.27638 8.56506 3.11887 8.49561 3.00274 8.37199C2.8866 8.24837 2.82136 8.08071 2.82136 7.90588V7.46643Z"
        fill={fill}
      />
      <path
        d="M9.55067 2.6322H2.61494C2.30836 2.6322 2.01434 2.76184 1.79756 2.9926C1.58077 3.22336 1.45898 3.53633 1.45898 3.86267V4.43396H10.7066V3.86267C10.7066 3.53633 10.5848 3.22336 10.3681 2.9926C10.1513 2.76184 9.85725 2.6322 9.55067 2.6322V2.6322Z"
        fill={fill}
      />
    </svg>
  );
}

export function FileIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.63461 5.29687H6.74472C6.48194 5.29687 6.22992 5.18575 6.04411 4.98796C5.85829 4.79017 5.7539 4.52191 5.7539 4.24219V1.16602C5.7539 1.14271 5.7452 1.12035 5.72972 1.10387C5.71423 1.08738 5.69323 1.07812 5.67133 1.07812H3.77226C3.42189 1.07813 3.08586 1.22628 2.83811 1.49001C2.59036 1.75373 2.45117 2.11141 2.45117 2.48437V9.51562C2.45117 9.88858 2.59036 10.2463 2.83811 10.51C3.08586 10.7737 3.42189 10.9219 3.77226 10.9219H8.39609C8.74646 10.9219 9.08249 10.7737 9.33024 10.51C9.57799 10.2463 9.71718 9.88858 9.71718 9.51562V5.38476C9.71718 5.36145 9.70848 5.3391 9.69299 5.32262C9.67751 5.30613 9.65651 5.29687 9.63461 5.29687Z"
        fill={fill}
      />
      <path
        d="M9.45299 4.51959L6.48445 1.3597C6.47868 1.35359 6.47134 1.34944 6.46335 1.34776C6.45537 1.34608 6.44709 1.34695 6.43957 1.35026C6.43205 1.35357 6.42561 1.35917 6.42108 1.36637C6.41654 1.37356 6.4141 1.38202 6.41406 1.39068V4.24296C6.41406 4.3362 6.44886 4.42562 6.5108 4.49155C6.57274 4.55748 6.65674 4.59452 6.74434 4.59452H9.42388C9.43202 4.59448 9.43997 4.59188 9.44673 4.58705C9.45348 4.58222 9.45875 4.57537 9.46186 4.56736C9.46497 4.55936 9.46579 4.55055 9.46421 4.54205C9.46263 4.53355 9.45873 4.52574 9.45299 4.51959Z"
        fill={fill}
      />
    </svg>
  );
}

export function UserGroup({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.3771 2.04545C5.3771 2.58794 5.18617 3.10821 4.84632 3.49181C4.50647 3.87541 4.04553 4.09091 3.5649 4.09091C3.08428 4.09091 2.62334 3.87541 2.28348 3.49181C1.94363 3.10821 1.7527 2.58794 1.7527 2.04545C1.7527 1.50297 1.94363 0.982697 2.28348 0.5991C2.62334 0.215503 3.08428 0 3.5649 0C4.04553 0 4.50647 0.215503 4.84632 0.5991C5.18617 0.982697 5.3771 1.50297 5.3771 2.04545ZM7.11681 8.18673C7.19655 8.63018 6.86456 9 6.46442 9H0.665381C0.264523 9 -0.0667476 8.63018 0.0115395 8.18673C0.178298 7.26198 0.623077 6.4307 1.27056 5.83364C1.91805 5.23658 2.72845 4.91044 3.56454 4.91044C4.40063 4.91044 5.21103 5.23658 5.85852 5.83364C6.506 6.4307 6.95078 7.26198 7.11754 8.18673M9.36539 8.18182H8.21283C8.2066 8.10224 8.19692 8.02306 8.18384 7.94455C8.04505 7.17269 7.75612 6.44527 7.3379 5.81482C7.87071 5.64889 8.4395 5.71818 8.92866 6.00861C9.41783 6.29904 9.79067 6.7888 9.97139 7.37836C10.1019 7.80545 9.76625 8.18182 9.36539 8.18182ZM7.91418 4.90909C8.29868 4.90909 8.66744 4.73669 8.93932 4.42981C9.2112 4.12293 9.36394 3.70672 9.36394 3.27273C9.36394 2.83874 9.2112 2.42252 8.93932 2.11564C8.66744 1.80877 8.29868 1.63636 7.91418 1.63636C7.52968 1.63636 7.16093 1.80877 6.88905 2.11564C6.61717 2.42252 6.46442 2.83874 6.46442 3.27273C6.46442 3.70672 6.61717 4.12293 6.88905 4.42981C7.16093 4.73669 7.52968 4.90909 7.91418 4.90909Z"
        fill={fill}
      />
    </svg>
  );
}

export function AccountIcon({ fill = '#3974F6', size = 13, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.25 9.3919C12.25 9.50019 12.2069 9.60406 12.1304 9.68063C12.0538 9.75721 11.9499 9.80023 11.8416 9.80023H0.408332C0.300036 9.80023 0.196175 9.75721 0.119598 9.68063C0.0430206 9.60406 0 9.50019 0 9.3919C0 9.2836 0.0430206 9.17974 0.119598 9.10316C0.196175 9.02659 0.300036 8.98357 0.408332 8.98357H11.8416C11.9499 8.98357 12.0538 9.02659 12.1304 9.10316C12.2069 9.17974 12.25 9.2836 12.25 9.3919ZM0.423645 3.78652C0.399358 3.70089 0.403717 3.60966 0.436058 3.52674C0.468399 3.44381 0.526951 3.37372 0.6028 3.32714L5.91112 0.0604854C5.97544 0.0209375 6.04947 0 6.12498 0C6.20049 0 6.27452 0.0209375 6.33885 0.0604854L11.6472 3.32714C11.723 3.37367 11.7816 3.4437 11.814 3.5266C11.8464 3.60949 11.8509 3.7007 11.8267 3.78634C11.8024 3.87198 11.7509 3.94737 11.6799 4.00102C11.6089 4.05468 11.5223 4.08367 11.4333 4.08358H10.2083V7.35024H11.025C11.1333 7.35024 11.2371 7.39326 11.3137 7.46983C11.3903 7.54641 11.4333 7.65027 11.4333 7.75857C11.4333 7.86687 11.3903 7.97073 11.3137 8.0473C11.2371 8.12388 11.1333 8.1669 11.025 8.1669H1.225C1.1167 8.1669 1.01284 8.12388 0.936262 8.0473C0.859685 7.97073 0.816665 7.86687 0.816665 7.75857C0.816665 7.65027 0.859685 7.54641 0.936262 7.46983C1.01284 7.39326 1.1167 7.35024 1.225 7.35024H2.04166V4.08358H0.816665C0.727744 4.08361 0.641245 4.05461 0.570308 4.001C0.499371 3.94738 0.447875 3.87207 0.423645 3.78652ZM6.94165 6.9419C6.94165 7.0502 6.98467 7.15406 7.06125 7.23064C7.13782 7.30722 7.24168 7.35024 7.34998 7.35024C7.45828 7.35024 7.56214 7.30722 7.63872 7.23064C7.71529 7.15406 7.75831 7.0502 7.75831 6.9419V4.49191C7.75831 4.38361 7.71529 4.27975 7.63872 4.20318C7.56214 4.1266 7.45828 4.08358 7.34998 4.08358C7.24168 4.08358 7.13782 4.1266 7.06125 4.20318C6.98467 4.27975 6.94165 4.38361 6.94165 4.49191V6.9419ZM4.49165 6.9419C4.49165 7.0502 4.53468 7.15406 4.61125 7.23064C4.68783 7.30722 4.79169 7.35024 4.89999 7.35024C5.00828 7.35024 5.11214 7.30722 5.18872 7.23064C5.2653 7.15406 5.30832 7.0502 5.30832 6.9419V4.49191C5.30832 4.38361 5.2653 4.27975 5.18872 4.20318C5.11214 4.1266 5.00828 4.08358 4.89999 4.08358C4.79169 4.08358 4.68783 4.1266 4.61125 4.20318C4.53468 4.27975 4.49165 4.38361 4.49165 4.49191V6.9419Z"
        fill={fill}
      />
    </svg>
  );
}

export function TransactionIcon({ fill = '#3974F6', size = 10, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.2381 6.42857C5.2381 6.85238 5.32381 7.25238 5.47619 7.61905H0.952381C0.699794 7.61905 0.457552 7.51871 0.278946 7.3401C0.10034 7.1615 0 6.91925 0 6.66667V0.952381C0 0.699794 0.10034 0.457552 0.278946 0.278946C0.457552 0.10034 0.699794 0 0.952381 0H8.57143C9.1 0 9.52381 0.42381 9.52381 0.952381V3.57143C9.15714 3.41905 8.75714 3.33333 8.33333 3.33333H8.57143V1.90476H0.952381V3.33333H8.33333C7.51242 3.33333 6.72514 3.65944 6.14467 4.23991C5.5642 4.82038 5.2381 5.60766 5.2381 6.42857ZM8.09524 7.61905C7.7795 7.61905 7.4767 7.49362 7.25344 7.27037C7.03019 7.04711 6.90476 6.74431 6.90476 6.42857C6.90476 6.2381 6.94762 6.05714 7.02857 5.89524L6.50952 5.37619C6.30952 5.67619 6.19048 6.0381 6.19048 6.42857C6.19048 7.48095 7.04286 8.33333 8.09524 8.33333V9.04762L9.16667 7.97619L8.09524 6.90476V7.61905ZM8.09524 4.52381V3.80952L7.02381 4.88095L8.09524 5.95238V5.2381C8.41097 5.2381 8.71377 5.36352 8.93703 5.58678C9.16029 5.81004 9.28571 6.11284 9.28571 6.42857C9.28571 6.61905 9.24286 6.8 9.1619 6.96191L9.68095 7.48095C9.88095 7.18095 10 6.81905 10 6.42857C10 5.37619 9.14762 4.52381 8.09524 4.52381Z"
        fill={fill}
      />
    </svg>
  );
}

export function AuditIcon({ fill = '#3974F6', size = 10, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.734784 0.0947903 0.48043 0.263518 0.292893C0.432246 0.105357 0.66109 0 0.899707 0L8.09736 0C8.33598 0 8.56483 0.105357 8.73355 0.292893C8.90228 0.48043 8.99707 0.734784 8.99707 1V6H5.69814C5.61861 6 5.54232 6.03512 5.48608 6.09763C5.42984 6.16014 5.39824 6.24493 5.39824 6.33333V10H0.899707C0.66109 10 0.432246 9.89464 0.263518 9.70711C0.0947903 9.51957 0 9.26522 0 9L0 1ZM7.19766 2.66667H1.79941V2H7.19766V2.66667Z"
        fill={fill}
      />
      <path
        d="M6.00195 9.99935H6.05354C6.29207 9.99912 6.52076 9.89361 6.68933 9.70602L8.73766 7.43002C8.90622 7.24255 9.00093 6.98838 9.00098 6.72335V6.66602H6.00195V9.99935Z"
        fill={fill}
      />
    </svg>
  );
}

export function EventIcon({ fill = '#3974F6', size = 10, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.1875 0C2.27038 0 2.34987 0.032924 2.40847 0.0915291C2.46708 0.150134 2.5 0.22962 2.5 0.3125V0.625H7.5V0.3125C7.5 0.22962 7.53292 0.150134 7.59153 0.0915291C7.65013 0.032924 7.72962 0 7.8125 0C7.89538 0 7.97487 0.032924 8.03347 0.0915291C8.09208 0.150134 8.125 0.22962 8.125 0.3125V0.625H8.75C9.08152 0.625 9.39946 0.756696 9.63388 0.991117C9.8683 1.22554 10 1.54348 10 1.875V8.75C10 9.08152 9.8683 9.39946 9.63388 9.63388C9.39946 9.8683 9.08152 10 8.75 10H1.25C0.918479 10 0.600537 9.8683 0.366117 9.63388C0.131696 9.39946 0 9.08152 0 8.75V1.875C0 1.54348 0.131696 1.22554 0.366117 0.991117C0.600537 0.756696 0.918479 0.625 1.25 0.625H1.875V0.3125C1.875 0.22962 1.90792 0.150134 1.96653 0.0915291C2.02513 0.032924 2.10462 0 2.1875 0ZM8.40875 1.875H1.59063C1.40313 1.875 1.25 2.015 1.25 2.1875V2.8125C1.25 2.985 1.4025 3.125 1.59063 3.125H8.40938C8.59688 3.125 8.75 2.985 8.75 2.8125V2.1875C8.75 2.015 8.5975 1.875 8.40875 1.875ZM7.1875 4.375C7.10462 4.375 7.02513 4.40792 6.96653 4.46653C6.90792 4.52513 6.875 4.60462 6.875 4.6875V5.3125C6.875 5.39538 6.90792 5.47487 6.96653 5.53347C7.02513 5.59208 7.10462 5.625 7.1875 5.625H7.8125C7.89538 5.625 7.97487 5.59208 8.03347 5.53347C8.09208 5.47487 8.125 5.39538 8.125 5.3125V4.6875C8.125 4.60462 8.09208 4.52513 8.03347 4.46653C7.97487 4.40792 7.89538 4.375 7.8125 4.375H7.1875Z"
        fill={fill}
      />
    </svg>
  );
}

export function CustomerIcon({ fill = '#3974F6', size = 64, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M58.1333 42C59.6893 42 61.1815 41.4469 62.2817 40.4623C63.3819 39.4777 64 38.1424 64 36.75L64 5.25C64 3.85761 63.3819 2.52225 62.2817 1.53769C61.1815 0.553121 59.6893 -7.73223e-07 58.1333 -7.0521e-07L42 0L42 42L58.1333 42ZM50.1714 35.8125C49.3379 35.8125 48.5385 35.5162 47.9491 34.9887C47.3597 34.4613 47.0286 33.7459 47.0286 33L47.0286 28.5C47.0286 27.7541 47.3597 27.0387 47.9491 26.5113C48.5385 25.9838 49.3379 25.6875 50.1714 25.6875L52.2667 25.6875C53.1002 25.6875 53.8996 25.9838 54.489 26.5113C55.0784 27.0387 55.4095 27.7541 55.4095 28.5L55.4095 33C55.4095 33.7459 55.0784 34.4613 54.489 34.9887C53.8996 35.5162 53.1002 35.8125 52.2667 35.8125L50.1714 35.8125Z"
        fill={fill}
      />
      <path
        d="M32 5.25L32 36.75C32 38.1424 32.5756 39.4777 33.6002 40.4623C34.6248 41.4469 36.0144 42 37.4634 42L40 42L40 -3.49691e-07L37.4634 -2.38814e-07C36.0144 -1.75476e-07 34.6248 0.553122 33.6002 1.53769C32.5756 2.52225 32 3.85761 32 5.25V5.25Z"
        fill={fill}
      />
      <path
        d="M18.4144 21.0465C24.2017 21.0465 28.9369 16.3113 28.9369 10.524C28.9369 4.73659 24.2017 0.00146484 18.4144 0.00146484C12.627 0.00146484 7.89187 4.73659 7.89187 10.524C7.89187 16.3113 12.627 21.0465 18.4144 21.0465ZM28.9369 42.0915V28.1492C26.0432 27.0969 22.3603 26.3077 18.4144 26.3077C8.15494 26.3077 0 31.0428 0 36.8302V42.0915H28.9369Z"
        fill={fill}
      />
    </svg>
  );
}

export function CustomerRequestIcon({ fill = '#3974F6', size = 64, ...props }: IconProps) {
  const parsed = parseFloat(String(size));
  const unit = String(size).replace(String(parsed), '');
  const widthAttr =
    typeof size === 'number' ? size + 3 : Number.isNaN(parsed) ? size : `${parsed + 3}${unit}`;

  return (
    <svg
      width={widthAttr}
      height={size}
      viewBox="0 0 17 12"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8 12H0V8.4C0.63652 8.4 1.24697 8.14714 1.69706 7.69706C2.14714 7.24697 2.4 6.63652 2.4 6C2.4 5.36348 2.14714 4.75303 1.69706 4.30294C1.24697 3.85286 0.63652 3.6 0 3.6V0H10.8V3H12V0H16.8V3.6C16.1635 3.6 15.553 3.85286 15.1029 4.30294C14.6529 4.75303 14.4 5.36348 14.4 6C14.4 6.63652 14.6529 7.24697 15.1029 7.69706C15.553 8.14714 16.1635 8.4 16.8 8.4V12H12V9H10.8V12ZM10.8 4.2V7.8H12V4.2H10.8Z"
        fill={fill}
      />
    </svg>
  );
}

export function StablecoinManagementIcon({ fill = '#3974F6', size = 64, ...props }: IconProps) {
  return (
    <svg width={size} height={Number(size) - 1} viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13.9424 0C14.8663 4.10088e-05 15.6151 0.752018 15.6152 1.67969C15.6152 2.41085 15.1494 3.03085 14.5 3.26172V8.99121C15.557 9.10855 16.5146 9.55565 17.2695 10.2275L24.7217 5.36816C24.6044 5.09589 24.5382 4.79598 24.5381 4.48047C24.5381 3.24335 25.5375 2.24023 26.7695 2.24023C28.0014 2.2404 29 3.24345 29 4.48047C28.9997 5.71727 28.0013 6.71956 26.7695 6.71973C26.2578 6.71973 25.7875 6.5449 25.4111 6.25391L18.0254 11.0703C18.6141 11.8961 18.9619 12.907 18.9619 14C18.9619 14.8449 18.7527 15.6404 18.3867 16.3398L21.8643 19.376C22.1436 19.1659 22.4894 19.0401 22.8652 19.04C23.7892 19.04 24.5379 19.792 24.5381 20.7197C24.5381 21.6476 23.7892 22.4004 22.8652 22.4004C21.9413 22.4003 21.1924 21.6475 21.1924 20.7197C21.1924 20.5809 21.2106 20.4464 21.2422 20.3174L17.7559 17.2734C16.949 18.2204 15.8001 18.8635 14.5 19.0078V24.7373C15.1495 24.9681 15.6152 25.589 15.6152 26.3203C15.6151 27.248 14.8663 28 13.9424 28C13.0185 28 12.2697 27.248 12.2695 26.3203C12.2695 25.589 12.7352 24.968 13.3848 24.7373V19.0078C11.6584 18.8162 10.1968 17.7462 9.45215 16.252L5.5459 18.165C5.56521 18.2672 5.57715 18.3727 5.57715 18.4805C5.5769 19.4079 4.82795 20.1599 3.9043 20.1602C2.98044 20.1602 2.23072 19.4081 2.23047 18.4805C2.23047 17.5526 2.98028 16.7998 3.9043 16.7998C4.31448 16.7999 4.68951 16.9492 4.98047 17.1953L9.06543 15.1943C8.97275 14.8114 8.92285 14.4115 8.92285 14C8.92285 13.5065 8.99432 13.0298 9.12598 12.5791L2.90527 9.53223C2.59939 9.8677 2.16153 10.0801 1.67285 10.0801C0.74907 10.08 0.000210168 9.32797 0 8.40039C0 7.47263 0.74894 6.71985 1.67285 6.71973C2.59687 6.71973 3.3457 7.47255 3.3457 8.40039C3.3457 8.43355 3.34271 8.46634 3.34082 8.49902L9.55859 11.5449C10.3311 10.1572 11.7375 9.17403 13.3848 8.99121V3.26172C12.7353 3.03089 12.2695 2.4109 12.2695 1.67969C12.2697 0.751993 13.0185 0 13.9424 0ZM13.9424 10.0801C11.7863 10.0801 10.0381 11.844 10.0381 14C10.0381 16.156 11.7863 17.9199 13.9424 17.9199C16.0984 17.9199 17.8457 16.156 17.8457 14C17.8457 11.844 16.0984 10.0801 13.9424 10.0801Z" fill={fill} />
      <path d="M14.1194 13.5892C15.3731 13.7137 16 14.0124 16 14.8838C16 15.556 15.403 16.0788 14.5075 16.2033V16.8009C14.4776 16.9253 14.388 17 14.2686 17H13.8209C13.6716 16.9751 13.5821 16.9004 13.5821 16.8009V16.2033C12.597 16.0788 12.1194 15.6307 12 15.0083V14.9834C12 14.8838 12.0896 14.8091 12.2089 14.8091H12.7164C12.806 14.8091 12.8955 14.859 12.9253 14.9585C13.0149 15.3319 13.2835 15.6058 14.0597 15.6058C14.6268 15.6058 15.0448 15.332 15.0448 14.9336C15.0448 14.5353 14.7761 14.3859 13.9403 14.2615C12.6865 14.1369 12.0896 13.8133 12.0896 12.9917C12.0896 12.3693 12.6567 11.8714 13.5522 11.7718V11.1992C13.5821 11.0747 13.6716 11 13.7911 11H14.2388C14.3881 11.0249 14.4776 11.0996 14.4776 11.1992V11.7967C15.1642 11.8465 15.7015 12.2697 15.8209 12.8174V12.8424C15.8209 12.9419 15.7313 13.0166 15.6119 13.0166H15.1343C15.0448 13.0166 14.9552 12.9668 14.9254 12.8921C14.7761 12.5187 14.4776 12.3693 13.9403 12.3693C13.3433 12.3693 13.0448 12.5933 13.0448 12.9419C13.0448 13.2905 13.2239 13.4896 14.1194 13.5892Z" fill={fill} />
    </svg>

  );
}

export function DashboardIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 3h7v7H3V3zm11 0h7v11h-7V3zm0 15h7v3h-7v-3zM3 14h7v7H3v-7z" fill={fill} />
    </svg>
  );
}

export function JournalsIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4 19.5V2C4 1.44772 4.44772 1 5 1H20V21H6.5C5.11929 21 4 19.8807 4 18.5V19.5z" stroke={fill} strokeWidth="2"/>
    </svg>
  );
}

export function EntriesIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line x1="8" y1="6" x2="21" y2="6" stroke={fill} strokeWidth="2"/>
      <line x1="8" y1="12" x2="21" y2="12" stroke={fill} strokeWidth="2"/>
      <line x1="8" y1="18" x2="21" y2="18" stroke={fill} strokeWidth="2"/>
      <line x1="3" y1="6" x2="3.01" y2="6" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
      <line x1="3" y1="12" x2="3.01" y2="12" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
      <line x1="3" y1="18" x2="3.01" y2="18" stroke={fill} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

export function BalanceContainersIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function SeedOperationsIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 3v18M8 7l4-4 4 4M20 21H4" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function ReconciliationIcon({ fill = '#3974F6', size = 12, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 11l3 3L22 4" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}